var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _vm.viewMode == "list"
                ? _c("span", { staticClass: "ik-list-title" }, [
                    _c(
                      "span",
                      { staticClass: "svg-container ik-list-icon" },
                      [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                      1
                    ),
                    _c("span", [_vm._v("数据列表")]),
                  ])
                : _vm._e(),
              _vm.viewMode === "list"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listCreateBtn },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listUpdateBtn },
                        },
                        [_vm._v("修改")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDetailsBtn },
                        },
                        [_vm._v("详情")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listOutBtn },
                        },
                        [_vm._v("出库")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listBackBtn },
                        },
                        [_vm._v("回退")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode === "info"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCreateBtn },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoUpdateBtn },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCopyBtn },
                            },
                            [_vm._v("复制")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.formInBtn },
                            },
                            [_vm._v("出库")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.formBackBtn },
                            },
                            [_vm._v("回退")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.printOpen },
                            },
                            [_vm._v("打印")]
                          )
                        : _vm._e(),
                      _vm.mode == "add" || _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoSaveBtn },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.infoCancelBtn },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _vm.viewMode == "info"
                ? _c(
                    "el-form",
                    {
                      staticClass: "ik-info-head",
                      attrs: {
                        id: "ik-info-head",
                        inline: true,
                        "label-width": "120px",
                        disabled: _vm.mode == "details",
                      },
                      on: { validate: _vm.validate },
                      model: {
                        value: _vm.data.head,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "head", $$v)
                        },
                        expression: "data.head",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_id",
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  "default-value": 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["id"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "id", $$v)
                                  },
                                  expression: "data.head['id']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_code",
                                attrs: {
                                  code: "code",
                                  name: "编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["code"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "code", $$v)
                                  },
                                  expression: "data.head['code']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-datetime", {
                                ref: "input_ordTime",
                                attrs: {
                                  code: "ordTime",
                                  name: "单据时间",
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["ordTime"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "ordTime", $$v)
                                  },
                                  expression: "data.head['ordTime']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-datetime", {
                                ref: "input_businessTime",
                                attrs: {
                                  code: "businessTime",
                                  name: "业务时间",
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["businessTime"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "businessTime", $$v)
                                  },
                                  expression: "data.head['businessTime']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_positionId",
                                attrs: {
                                  code: "positionId",
                                  name: "药库ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "positionId", $$v)
                                  },
                                  expression: "data.head['positionId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_positionCode",
                                attrs: {
                                  code: "positionCode",
                                  name: "药库编码",
                                  url: "clinic/inventory/inventory/position/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: { storeCode: _vm.storeCode },
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["positionCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "positionCode", $$v)
                                  },
                                  expression: "data.head['positionCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_positionName",
                                attrs: {
                                  code: "positionName",
                                  name: "药库名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "positionName", $$v)
                                  },
                                  expression: "data.head['positionName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_positionPositionSign",
                                attrs: {
                                  code: "positionPositionSign",
                                  name: "位置标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.positionSign),
                                  disabled: true,
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionPositionSign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "positionPositionSign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['positionPositionSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_positionClassifySign",
                                attrs: {
                                  code: "positionClassifySign",
                                  name: "分类标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.classifySign),
                                  disabled: true,
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["positionClassifySign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "positionClassifySign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['positionClassifySign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_outTypeId",
                                attrs: {
                                  code: "outTypeId",
                                  name: "出库类型ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["outTypeId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "outTypeId", $$v)
                                  },
                                  expression: "data.head['outTypeId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_outTypeCode",
                                attrs: {
                                  code: "outTypeCode",
                                  name: "出库类型编码",
                                  url: "base/dictionary/datadic/datadictionary/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: { directoryCode: "OutType" },
                                  "default-value": "",
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["outTypeCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "outTypeCode", $$v)
                                  },
                                  expression: "data.head['outTypeCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_outTypeName",
                                attrs: {
                                  code: "outTypeName",
                                  name: "出库类型名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["outTypeName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "outTypeName", $$v)
                                  },
                                  expression: "data.head['outTypeName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_executeSign",
                                attrs: {
                                  code: "executeSign",
                                  name: "执行标识",
                                  "default-value": "1",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.executeSign),
                                  disabled: true,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["executeSign"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "executeSign", $$v)
                                  },
                                  expression: "data.head['executeSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_sourceTypeSign",
                                attrs: {
                                  code: "sourceTypeSign",
                                  name: "来源类型",
                                  "default-value": "1",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(
                                    _vm.jsonStr.sourceTypeSign
                                  ),
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["sourceTypeSign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "sourceTypeSign",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['sourceTypeSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_sourceCode",
                                attrs: {
                                  code: "sourceCode",
                                  name: "来源单号",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["sourceCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "sourceCode", $$v)
                                  },
                                  expression: "data.head['sourceCode']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode == "info"
                ? _c(
                    "el-tabs",
                    {
                      ref: "ik-info-body",
                      staticClass: "in-ord-tabs-info",
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          key: _vm.bodyMap[0].key,
                          staticStyle: { height: "100%" },
                          attrs: {
                            name: _vm.bodyMap[0].key,
                            label: _vm.bodyMap[0].name,
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                                {
                                  name: "horizontal-scroll",
                                  rawName: "v-horizontal-scroll",
                                  value: "always",
                                  expression: "'always'",
                                },
                              ],
                              ref: "tablesub",
                              staticClass: "ik-list-table",
                              attrs: {
                                data: _vm.data.body[_vm.bodyMap[0].key],
                                "element-loading-text": "加载中...",
                                stripe: true,
                                border: true,
                                fit: true,
                                height: "100%",
                                "header-row-class-name":
                                  "ik-list-table-header-row",
                                "header-cell-class-name":
                                  "ik-list-table-header-cell",
                                "row-class-name": "ik-list-table-body-row",
                                "cell-class-name": "ik-list-table-body-cell",
                                "highlight-current-row": true,
                              },
                            },
                            [
                              _vm.mode !== "details"
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "pluss",
                                      label: "操作",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "button-action",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        padding: "0px 12px",
                                                      },
                                                    },
                                                    [_vm._v("操作")]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "26px",
                                                        height: "26px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: {
                                                        circle: "",
                                                        title: "添加首行",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addRow(
                                                            _vm.activeTab,
                                                            -1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("+")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "button-action",
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "28px",
                                                        height: "28px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: { circle: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.addRow(
                                                            _vm.bodyMap[0].key,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("+")]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "28px",
                                                        height: "28px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: { circle: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.delRow(
                                                            _vm.bodyMap[0].key,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2391271428
                                    ),
                                  })
                                : _vm._e(),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "materielId",
                                  name: "药品ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "materielCode",
                                  name: "药品编码",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "materielName",
                                  name: "药品名称",
                                  url: "clinic/inventory/inventory/inventory/find/findBatchInventoryPagination",
                                  "filed-list": [
                                    { code: "materielCode", name: "编码" },
                                    { code: "materielIotCode", name: "条码" },
                                    { code: "materielName", name: "名称" },
                                    { code: "batchCode", name: "批次" },
                                    {
                                      code: "qualitySign",
                                      name: "品质",
                                      type: "select",
                                      options: _vm.toJson(
                                        _vm.jsonStr.qualitySign
                                      ),
                                    },
                                    {
                                      code: "manufacturerName",
                                      name: "生产商",
                                    },
                                    { code: "supplierName", name: "供应商" },
                                    {
                                      code: "number",
                                      name: "余量",
                                      type: "number",
                                    },
                                    {
                                      code: "costPrice",
                                      name: "成本单价",
                                      type: "number",
                                    },
                                  ],
                                  "search-key": "materielName",
                                  searcher: {
                                    storeCode: _vm.storeCode,
                                    positionCode: _vm.data.head["positionCode"],
                                  },
                                  "popup-width": "100%",
                                  edit: _vm.mode !== "details",
                                },
                                on: {
                                  onFieldChange: _vm.onBodyFieldChange,
                                  onPopupClick: _vm.bodyPopupClick,
                                },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "supplierId",
                                  name: "供应商家ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "supplierCode",
                                  name: "供应商家编码",
                                  url: "clinic/clinicdic/clinicmedicinedic/clinicchaindic/find/findPagination",
                                  "filed-list": [
                                    {
                                      code: "chainDictionaryCode",
                                      name: "编码",
                                    },
                                    {
                                      code: "chainDictionaryName",
                                      name: "名称",
                                    },
                                  ],
                                  "search-key": "chainDictionaryName",
                                  searcher: {
                                    storeCode: _vm.storeCode,
                                    effectiveSign: "1",
                                  },
                                  edit: false,
                                },
                                on: {
                                  onFieldChange: _vm.onBodyFieldChange,
                                  onPopupClick: _vm.bodyPopupClick,
                                },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "supplierName",
                                  name: "供应商家名称",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "manufacturerId",
                                  name: "生产商家ID",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "manufacturerCode",
                                  name: "生产商家编码",
                                  url: "clinic/clinicdic/clinicmedicinedic/clinicchaindic/find/findPagination",
                                  "filed-list": [
                                    {
                                      code: "chainDictionaryCode",
                                      name: "编码",
                                    },
                                    {
                                      code: "chainDictionaryName",
                                      name: "名称",
                                    },
                                  ],
                                  "search-key": "chainDictionaryName",
                                  searcher: {
                                    storeCode: _vm.storeCode,
                                    effectiveSign: "1",
                                  },
                                  edit: false,
                                },
                                on: {
                                  onFieldChange: _vm.onBodyFieldChange,
                                  onPopupClick: _vm.bodyPopupClick,
                                },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "manufacturerName",
                                  name: "生产商家名称",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-select", {
                                attrs: {
                                  code: "qualitySign",
                                  name: "品质标识",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.qualitySign),
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "chandi",
                                  name: "产地",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-datetime", {
                                attrs: {
                                  code: "proDate",
                                  name: "生产日期",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "expirationNumber",
                                  name: "保质期",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "batchCode",
                                  name: "批次号",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "number",
                                  name: "数量",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "costPrice",
                                  name: "成本单价",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "costAmount",
                                  name: "成本金额",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "reNumber",
                                  name: "退货数量",
                                  "default-value": 0,
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "rePrice",
                                  name: "退货单价",
                                  "default-value": 0,
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "reAmount",
                                  name: "退货金额",
                                  "default-value": 0,
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "querybg" },
                [
                  _vm.viewMode == "list"
                    ? _c(
                        "el-collapse",
                        {
                          staticClass: "ik-list-searcher",
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.searcherActive,
                            callback: function ($$v) {
                              _vm.searcherActive = $$v
                            },
                            expression: "searcherActive",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "ik-list-searcher-item",
                              attrs: { title: "", name: "1" },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ik-list-searcher-item-titles",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "svg-container ik-list-icon",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "search" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" 查询条件 "),
                                  ]
                                ),
                              ]),
                              _c(
                                "el-form",
                                {
                                  staticClass: "ik-info-head",
                                  attrs: {
                                    id: "ik-info-head",
                                    inline: true,
                                    "label-width": "120px",
                                    disabled: false,
                                  },
                                  model: {
                                    value: _vm.searcher,
                                    callback: function ($$v) {
                                      _vm.searcher = $$v
                                    },
                                    expression: "searcher",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_code",
                                            attrs: {
                                              code: "code",
                                              name: "编码",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["code"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "code",
                                                  $$v
                                                )
                                              },
                                              expression: "searcher['code']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_executeSign",
                                            attrs: {
                                              code: "executeSign",
                                              name: "执行标识",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.executeSign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["executeSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "executeSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['executeSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_sourceTypeSign",
                                            attrs: {
                                              code: "sourceTypeSign",
                                              name: "来源类型",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.sourceTypeSign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["sourceTypeSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "sourceTypeSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['sourceTypeSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_positionCode",
                                            attrs: {
                                              code: "positionCode",
                                              name: "药库编码",
                                              url: "clinic/inventory/inventory/position/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {},
                                              "default-value": "",
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["positionCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "positionCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['positionCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_positionName",
                                            attrs: {
                                              code: "positionName",
                                              name: "药库名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["positionName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "positionName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['positionName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_outTypeCode",
                                            attrs: {
                                              code: "outTypeCode",
                                              name: "出库类型编码",
                                              url: "base/dictionary/datadic/datadictionary/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {
                                                directoryCode: "OutType",
                                              },
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["outTypeCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "outTypeCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['outTypeCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_outTypeName",
                                            attrs: {
                                              code: "outTypeName",
                                              name: "出库类型名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["outTypeName"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "outTypeName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['outTypeName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "query-class" }, [
                                _c(
                                  "div",
                                  { staticClass: "query-btn-warp" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.searchBtn },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.resetBtn },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.viewMode == "list"
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "table",
                      staticClass: "ik-list-table",
                      attrs: {
                        data: _vm.tableData,
                        "element-loading-text": "加载中...",
                        stripe: true,
                        border: true,
                        fit: true,
                        height: "calc(100% - 50px)",
                        "header-row-class-name": "ik-list-table-header-row",
                        "header-cell-class-name": "ik-list-table-header-cell",
                        "row-class-name": "ik-list-table-body-row",
                        "cell-class-name": "ik-list-table-body-cell",
                        "highlight-current-row": true,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("ik-column-id", {
                        attrs: { code: "id", name: "ID", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "code", name: "编码", edit: false },
                      }),
                      _c("ik-column-datetime", {
                        attrs: {
                          code: "ordTime",
                          name: "单据时间",
                          edit: false,
                        },
                      }),
                      _c("ik-column-datetime", {
                        attrs: {
                          code: "businessTime",
                          name: "业务时间",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: { code: "storeId", name: "门店ID", edit: false },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "positionId",
                          name: "药库ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "positionCode",
                          name: "药库编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "positionName",
                          name: "药库名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "outTypeId",
                          name: "出库类型ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "outTypeCode",
                          name: "出库类型编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "outTypeName",
                          name: "出库类型名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "executeSign",
                          name: "执行标识",
                          "key-field": "key",
                          "value-field": "value",
                          "default-value": "1",
                          options: _vm.toJson(_vm.jsonStr.executeSign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "sourceTypeSign",
                          name: "来源类型",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.sourceTypeSign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "sourceCode",
                          name: "来源单号",
                          edit: false,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _vm.viewMode == "list"
                ? _c("ik-pagination", {
                    ref: "ik_list_pagination",
                    attrs: {
                      "page-no": _vm.pagination.pageNo,
                      "page-size": _vm.pagination.pageSize,
                      "total-count": _vm.pagination.totalCount,
                    },
                    on: { pageChangeMethod: _vm.pageChange },
                  })
                : _c(
                    "el-row",
                    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "ik-list-enterprise-info",
                          attrs: { span: 6, offset: 12 },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" 导萃门诊管理系统 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退货信息",
            visible: _vm.dialogVisible,
            width: "80%",
            top: "16vh",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-tabs",
                {
                  ref: "ik-info-body",
                  staticClass: "in-ord-tabs-info",
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      key: _vm.bodyMap[0].key,
                      staticStyle: { height: "100%" },
                      attrs: {
                        name: _vm.bodyMap[0].key,
                        label: _vm.bodyMap[0].name,
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          ref: "tablesub",
                          staticClass: "ik-list-table",
                          attrs: {
                            data: _vm.digData[_vm.bodyMap[0].key + "List"],
                            "element-loading-text": "加载中...",
                            stripe: true,
                            border: true,
                            fit: true,
                            height: "100%",
                            "header-row-class-name": "ik-list-table-header-row",
                            "header-cell-class-name":
                              "ik-list-table-header-cell",
                            "row-class-name": "ik-list-table-body-row",
                            "cell-class-name": "ik-list-table-body-cell",
                            "highlight-current-row": true,
                          },
                        },
                        [
                          _c("ik-column-id", {
                            attrs: {
                              code: "id",
                              name: "ID",
                              edit: _vm.mode !== "details",
                            },
                          }),
                          _c("ik-column-id", {
                            attrs: {
                              code: "outOrdId",
                              name: "单据ID",
                              edit: false,
                            },
                          }),
                          _c("ik-column-hidden", {
                            attrs: {
                              code: "outOrdCode",
                              name: "单据编码",
                              edit: false,
                            },
                          }),
                          _c("ik-column-id", {
                            attrs: {
                              code: "materielId",
                              name: "药品ID",
                              edit: false,
                            },
                          }),
                          _c("ik-column-text", {
                            attrs: {
                              code: "materielCode",
                              name: "药品编码",
                              edit: false,
                            },
                          }),
                          _c("ik-column-text", {
                            attrs: {
                              code: "materielName",
                              name: "药品名称",
                              edit: false,
                            },
                          }),
                          _c("ik-column-id", {
                            attrs: {
                              code: "supplierId",
                              name: "供应商家ID",
                              edit: false,
                            },
                          }),
                          _c("ik-column-text", {
                            attrs: {
                              code: "supplierCode",
                              name: "供应商家编码",
                              edit: false,
                            },
                          }),
                          _c("ik-column-text", {
                            attrs: {
                              code: "supplierName",
                              name: "供应商家名称",
                              edit: false,
                            },
                          }),
                          _c("ik-column-id", {
                            attrs: {
                              code: "manufacturerId",
                              name: "生产商家ID",
                              edit: false,
                            },
                          }),
                          _c("ik-column-text", {
                            attrs: {
                              code: "manufacturerCode",
                              name: "生产商家编码",
                              edit: false,
                            },
                          }),
                          _c("ik-column-text", {
                            attrs: {
                              code: "manufacturerName",
                              name: "生产商家名称",
                              edit: false,
                            },
                          }),
                          _c("ik-column-select", {
                            attrs: {
                              code: "qualitySign",
                              name: "品质标识",
                              "key-field": "key",
                              "value-field": "value",
                              options: _vm.toJson(_vm.jsonStr.qualitySign),
                              edit: false,
                            },
                          }),
                          _c("ik-column-text", {
                            attrs: {
                              code: "batchCode",
                              name: "批次号",
                              edit: false,
                            },
                          }),
                          _c("ik-column-number", {
                            attrs: {
                              code: "number",
                              name: "数量",
                              edit: false,
                            },
                          }),
                          _c("ik-column-number", {
                            attrs: {
                              code: "costPrice",
                              name: "成本单价",
                              edit: false,
                            },
                          }),
                          _c("ik-column-number", {
                            attrs: {
                              code: "costAmount",
                              name: "成本金额",
                              edit: false,
                            },
                          }),
                          _c("ik-column-number", {
                            attrs: {
                              code: "reNumber",
                              name: "退货数量",
                              "default-value": 0,
                              edit: true,
                            },
                          }),
                          _c("ik-column-number", {
                            attrs: {
                              code: "rePrice",
                              name: "退货单价",
                              "default-value": 0,
                              edit: true,
                            },
                          }),
                          _c("ik-column-number", {
                            attrs: {
                              code: "reAmount",
                              name: "退货金额",
                              "default-value": 0,
                              edit: false,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.saveDigInfo },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("outOrdP", { ref: "outOrdRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }